import { AddNumberPopup } from './AddNumberPopup';
import { ResultPopup } from './ResultPopup';
import { CommonModal } from './CommonModal';

export default { AddNumberPopup, ResultPopup, CommonModal };
